import { Box, Typography, Divider } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { RADIUS } from '../../../layouts/dashboard/config-layout';
import { useEffect } from 'react';
import DocumentTypeHeader from './components/document.type.header';
import DocumentTypeController from '../controller/document.type.controller';
import CusttomAlertController from '../../../alert/controller/custom.alert.controller';
import { DocumentTypeChild, DocumentTypeChildrenData } from '../data/document.type.child';
import { DocumentModalNames } from '../data/document.type.modal.name';
import DocumentTypeModalView from './components/document.type.modal.view';
import CustomAlertModal from '../../../alert/components/custom.alert.modal';
import CustomDocumentTypeTable from './components/document.type.table';
import useScreenWidth from '../../../hooks/use-page-width';
const DocumentTypePage = () => {
  const doctype = DocumentTypeController();
  const alert = CusttomAlertController();
  const width = useScreenWidth();
  useEffect(() => {
    doctype.docTypeGetData(true, null);
    doctype.docTypeCateGetData(false);
  }, []);
  return (
    <>
      <Typography sx={{ px: 3, py: 2, color: '#f5f4f4' }}>ຈັດປະເພດເອກະສານ</Typography>
      <Box sx={{ px: width > 600 ? 3 : 0, paddingBottom: '15px' }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#f5f4f4',
            borderTopLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderTopRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderBottomLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderBottomRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
          }}
        >
          <Box>
            <DocumentTypeHeader
              ctrl={doctype}
              handleOpenDialog={() =>
                doctype?.onHandleModal(
                  DocumentTypeChildrenData.filter((e: DocumentTypeChild) =>
                    e.name.includes(DocumentModalNames.CREATE)
                  )[0]
                )
              }
            />
            <Divider sx={{ backgroundColor: '#D9D9D9' }} />
            <Typography
              fontSize={18}
              sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', p: 3 }}
            >
              <DescriptionOutlinedIcon />
              <Typography marginLeft={'10px'}>ຈັດປະເພດເອກະສານ</Typography>
            </Typography>
            <CustomDocumentTypeTable doctype={doctype} alert={alert} />
          </Box>
        </Box>
      </Box>
      <DocumentTypeModalView ctrl={doctype} />
      <CustomAlertModal ctrl={alert} />
    </>
  );
};

export default DocumentTypePage;
